import React, { useState } from "react";

// Рівні віддаленості q (стаття, табл. 1).
export const ZONE_OPTIONS = [
  { value: 1, label: "1 — громада міста" },
  { value: 2, label: "2 — область" },
  { value: 3, label: "3 — за межами області" },
];

// Віддаленість за замовчуванням для рядків із zone_missing. Спільний для
// аналізу файлу (локально) і для завантаження в систему (через API
// default-zone): компонент лише збирає вибір, а що з ним робити -- вирішує
// onApply. onCancel необов'язковий: API не вміє скасовувати значення.
const DefaultZoneBlock = ({
  missingCount,
  defaultCount,
  defaultZone,
  onApply,
  onCancel,
  busy = false,
  testId = "zone-block",
}) => {
  const [zoneDraft, setZoneDraft] = useState(2);

  if (missingCount <= 0 && defaultZone === null) return null;

  return (
    <div className="input-component" data-testid={testId}>
      {defaultZone === null ? (
        <>
          <p className="text-header" style={{ color: "var(--full-busy)" }}>
            Віддаленість не вказана або не розпізнана: {missingCount} рядків
          </p>
          <div className="form-container">
            <div className="input-block text-header">
              <select
                className="header-content-select"
                aria-label="Віддаленість за замовчуванням"
                value={zoneDraft}
                onChange={(e) => setZoneDraft(Number(e.target.value))}
              >
                {ZONE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <button type="button" className="restore-button" disabled={busy} onClick={() => onApply(zoneDraft)}>
              Задати віддаленість за замовчуванням
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="text-header">
            Віддаленість за замовчуванням ({ZONE_OPTIONS[defaultZone - 1].label}) задано для {defaultCount} рядків. Для
            них q не відображає реального місця проживання.
          </p>
          {onCancel && (
            <button type="button" className="restore-button" onClick={onCancel}>
              Скасувати
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default DefaultZoneBlock;
